import axios from 'axios'
import { getUrls } from '../../../common/constants'
import {
  ExecutionDetailResponse,
  TriggeredExecutionListResponse
} from '../types/TriggeredExecution'
import { ScriptFeedbackStep } from '../../mScripts/tessaScript/types/ScriptExecution'
import { fetchScript } from '../../mScripts/api'
import { prepareScriptState } from '../../mScripts/tessaScript/helpers/helpers'
import { getFeedbackStepsFromNodes } from '../../mScripts/tessaScript/redux/selectors'

export const fetchTriggeredExecutions = (
  robotId: number,
  from: string,
  to: string,
  limit = 100
) => {
  const url = getUrls('micro_manager_v6', 'triggered-executions').replace('{robotId}', robotId)
  return axios.get<TriggeredExecutionListResponse>(url, {
    params: { from, to, limit }
  })
}

export const fetchExecutionDetail = async (
  robotId: number,
  executionId: number
): Promise<{ data: ExecutionDetailResponse & { scriptFeedbackSteps: ScriptFeedbackStep[] } }> => {
  const url = getUrls('micro_manager_v6', 'execution-detail')
    .replace('{robotId}', robotId)
    .replace('{executionId}', executionId)
  const { data: detail } = await axios.get<ExecutionDetailResponse>(url)
  const { data: fullScript } = await fetchScript(robotId, detail.script.scriptReferenceId)
  const script = prepareScriptState(fullScript, [])
  const scriptFeedbackSteps = getFeedbackStepsFromNodes(
    detail.scriptExecutionSteps,
    script.scriptNodes
  )
  return { data: { ...detail, scriptFeedbackSteps } }
}
